import {defineAsyncComponent} from "vue";
import {Model} from "@/services/api";

export default class Newspaper extends Model {
    static relations = {
        events: require("@/services/models/lafil013").default,
        inventories: require("@/services/models/inventory").default,
    };

    toString() {
        return this.filename;
    }

    static route() {
        return 'newspapers';
    }

    detail() {
        return {
            title: this,
            component: defineAsyncComponent(() => import('@/components/newspapers/newspaper-details.vue')),
            props: {newspaper: this}
        };
    }
}
